const setGraphProjectAll = payload => {
  return {
    type: "setGraphProjectAll",
    payload
  };
};
export default setGraphProjectAll;
